import { useMemo } from 'react'
import { useIntlayer } from 'react-intlayer'
import { buildInsights } from '../application/build-insights'
import { useOverviewSummary } from '../hooks/use-overview-summary'
import { OverviewWidgetCard } from './overview-widget-card'
import { SummaryTicker } from './summary-ticker'
import { WelcomeGreeting } from './welcome-greeting'

const LOADING_VALUE = '—'

const OverviewPage = () => {
	const content = useIntlayer('overview')
	const { summary, isLoading, canViewMembers } = useOverviewSummary()

	const insights = useMemo(
		() =>
			buildInsights(summary, {
				youHave: content.insights.youHave.value,
				requestPendingSingular: content.insights.requestPendingSingular.value,
				requestPendingPlural: content.insights.requestPendingPlural.value,
				requestPendingAfter: content.insights.requestPendingAfter.value,
				teamApprovalBeforeSingular: content.insights.teamApprovalBeforeSingular.value,
				teamApprovalBeforePlural: content.insights.teamApprovalBeforePlural.value,
				teamApprovalLinkSingular: content.insights.teamApprovalLinkSingular.value,
				teamApprovalLinkPlural: content.insights.teamApprovalLinkPlural.value,
				teamApprovalAfter: content.insights.teamApprovalAfter.value,
				allClear: content.insights.allClear.value,
			}),
		[summary, content.insights],
	)

	const c = content.cards

	const membersValue = isLoading ? LOADING_VALUE : String(summary.activeTeamMembersCount)

	const workflowsValue = isLoading ? LOADING_VALUE : String(summary.activeWorkflowsCount)
	const workflowsDetail = isLoading
		? undefined
		: summary.activeWorkflowsCount === 0
			? c.workflows.none.value
			: c.workflows.running.value

	return (
		<div className='mt-2 pb-16 flex flex-col min-h-[calc(100vh-120px)] max-w-3xl mx-auto w-full'>
			<div className='flex flex-col items-center text-center pt-6 pb-10 w-full gap-4'>
				<WelcomeGreeting />
				<SummaryTicker insights={insights} />
			</div>

			<div className='grid grid-cols-[repeat(auto-fill,minmax(clamp(15rem,17dvw,18.75rem),1fr))] gap-3 w-full'>
				<OverviewWidgetCard
					label={c.workflows.label.value}
					value={workflowsValue}
					detail={workflowsDetail}
					href='/tasks/workflows'
				/>

				{canViewMembers ? (
					<OverviewWidgetCard
						label={c.teamMembers.label.value}
						value={membersValue}
						detail={c.teamMembers.detail.value}
						href='/hr'
					/>
				) : null}
			</div>
		</div>
	)
}

export { OverviewPage }
